export const getIconUrl = ({ name, color, extension = 'svg' }) => {
  let path = name;
  if (color) {
    path += `_${color}`;
  }
  path += `.${extension}`;

  return `https://res.cloudinary.com/letsdothiscom/image/upload/v1558527272/static-assets/icons/${path}`;
};
